// prettier-ignore
import * as Sentry from '@sentry/browser';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import 'antd/dist/reset.css';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <StyleProvider hashPriority="high">
    <ConfigProvider
      theme={{
        token: {
          colorLink: '#0B77C0',
          colorLinkHover: '#2d92cc',
          colorLinkActive: '#025799',
          colorPrimary: '#0B77C0',
          fontFamily: '"Roboto", "Segoe UI", sans-serif',
          colorBgLayout: '#FCFDFF'
        }
      }}
    >
      <App />
    </ConfigProvider>
  </StyleProvider>
);
